<template>
  <div class="d-flex ai-center bg-white">
    <input
        v-vk-focus
        :value="value"
        aria-label="Home Services Search Input"
        type="text"
        class="SEARCH-INPUT input bd-transparent c-gray70"
        :placeholder="placeholderText"
        visible-placeholder
        selenium="subtask-search-input"
        @input.capture="$emit('input', $event.target.value)"
        @input="keyboard"
        @focus="focused = true"
        @keydown.esc.prevent="$emit('clear')"
        @keydown.down.prevent="keyboard(DOWN)"
        @keydown.up.prevent="keyboard(UP)"
        @keydown.enter.prevent="$emit('magnify')"
        @keydown.tab.prevent="keyboard(TAB)">
    <button
        aria-label="Search"
        class="SEARCH-BTN bg-depot bd-transparent"
        selenium="task-search-button"
        @click="showModal = true">
      <vk-icon name="magnifyglass" class="c-white" size="20" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'search-input',
  props: {
    results: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: String,
      required: true,
    },
    placeholderText: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      selected: -1,
    };
  },
  created () {
    this.DOWN = 'down';
    this.UP = 'up';
    this.TAB = 'tab';
    this.ESC = 'escape';
  },
  methods: {
    select (result, resultView, rank) {
      this.$emit('select', { result, resultView, rank });
      this.focused = false;
    },
    keyboard (key) {
      const max = this.results.length;
      switch (key) {
        case this.DOWN:
          this.selected = this.selected + 1 >= max ? this.selected : this.selected + 1;
          this.$emit('selected', this.selected);
          break;

        case this.UP:
          this.selected = this.selected - 1 < 0 ? 0 : this.selected - 1;
          this.$emit('selected', this.selected);
          break;

        case this.TAB:
          this.selected = this.selected + 1 >= max ? 0 : this.selected + 1;
          this.$emit('selected', this.selected);
          break;

        case this.ESC:
          this.selected = -1;
          this.$emit('selected', this.selected);
          break;

        default:
          this.$emit('search');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

$size: 32px;

.SEARCH-INPUT {
  height: $size;
  font-size: 14px;
}

.SEARCH-BTN {
  padding: 4px;
  width: $size;
  height: $size;
}
</style>
